/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimDto } from './ClaimDto';
import {
    ClaimDtoFromJSON,
    ClaimDtoFromJSONTyped,
    ClaimDtoToJSON,
    ClaimDtoToJSONTyped,
} from './ClaimDto';

/**
 * 
 * @export
 * @interface UserWithClaimsDto
 */
export interface UserWithClaimsDto {
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithClaimsDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithClaimsDto
     */
    isLocked?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserWithClaimsDto
     */
    lockoutEnd?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithClaimsDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {Array<ClaimDto>}
     * @memberof UserWithClaimsDto
     */
    claims?: Array<ClaimDto> | null;
}

/**
 * Check if a given object implements the UserWithClaimsDto interface.
 */
export function instanceOfUserWithClaimsDto(value: object): value is UserWithClaimsDto {
    return true;
}

export function UserWithClaimsDtoFromJSON(json: any): UserWithClaimsDto {
    return UserWithClaimsDtoFromJSONTyped(json, false);
}

export function UserWithClaimsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithClaimsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'lockoutEnd': json['lockoutEnd'] == null ? undefined : (new Date(json['lockoutEnd'])),
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ClaimDtoFromJSON)),
    };
}

export function UserWithClaimsDtoToJSON(json: any): UserWithClaimsDto {
    return UserWithClaimsDtoToJSONTyped(json, false);
}

export function UserWithClaimsDtoToJSONTyped(value?: UserWithClaimsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'isEnabled': value['isEnabled'],
        'isLocked': value['isLocked'],
        'lockoutEnd': value['lockoutEnd'] == null ? value['lockoutEnd'] : value['lockoutEnd'].toISOString(),
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'claims': value['claims'] == null ? undefined : ((value['claims'] as Array<any>).map(ClaimDtoToJSON)),
    };
}

